import {makeAutoObservable} from 'mobx';
import moment from 'moment';
import _ from 'lodash';
import CalendarEventViewModel from './CalendarEventViewModel';
import {buildGroups} from './eventGroups';

const MAX_UPCOMING_DAYS = 3;
const ALL_DAY_TYPE_ORDER = ['holiday', 'birthday', 'anniversary', 'first_day', 'time_off_request'];

class WhatsGoingOnState {
  emojiReady;
  calendarEvents = [];
  upcomingWindowSize;

  constructor() {
    makeAutoObservable(this, {
      emojiReady: false
    });
  }

  receiveProps({emojiReady, calendarEvents, upcomingWindowSize}) {
    this.emojiReady = emojiReady;
    this.calendarEvents = calendarEvents;
    this.upcomingWindowSize = upcomingWindowSize;
  }

  get events() {
    return _.map(this.calendarEvents, event => new CalendarEventViewModel(event));
  }

  get todaysAgenda() {
    return this.agendaFor(moment().startOf('day'), 'today');
  }

  get upcomingAgendas() {
    const today = moment().startOf('day');

    return _.chain(_.range(1, this.upcomingWindowSize + 1))
      .map(offset => this.agendaFor(today.clone().add(offset, 'days'), 'upcoming'))
      .filter('hasEvents')
      .take(MAX_UPCOMING_DAYS)
      .value();
  }

  agendaFor(date, scope) {
    const events = _.filter(this.events, event => event.occursOn(date));
    const key = date.format('YYYY-MM-DD');

    return {
      key,
      date,
      hasEvents: !_.isEmpty(events),
      groups: buildGroups(this.sortedForDisplay(events), scope, key)
    };
  }

  sortedForDisplay(events) {
    return [
      ..._.sortBy(_.filter(events, 'allDay'), [event => _.indexOf(ALL_DAY_TYPE_ORDER, event.type), 'title']),
      ..._.sortBy(_.reject(events, 'allDay'), [event => event.start.valueOf(), 'title'])
    ];
  }
}

export default WhatsGoingOnState;
